<template>
    <div class="service-detail">
        <header class="header">
            <h3>客户案例</h3>
            <el-breadcrumb class="fl" separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客户案例</el-breadcrumb-item>
                <el-breadcrumb-item>详情</el-breadcrumb-item>
            </el-breadcrumb>
        </header>
        <main class="main" ref="main">

        </main>
    </div>
</template>

<script>
    import { customerServiceDetail } from '../api/api.js'
    export default {
        name: 'customerServiceDetail',
        mounted() {
            customerServiceDetail({ id: this.$route.query.id }).then(res => {
                if (res.data.status === 1) {
                    this.$refs.main.innerHTML = res.data.data.content
                } else {

                }
            })
        },
        data() {
            return {

            };
        }
    }
</script>

<style scoped>
    .header {
        width: 100%;
        padding: 3% 15%;
        background-color: #2e324f;
        color: #ffffff;
        font-size: 24px;
    }

    .main {
        width: 70%;
        padding: 4% 15%;
        background-color: #f5f5f5;
    }
</style>



// WEBPACK FOOTER //
// src/components/customerServiceDetail.vue